// The keys of the cookies a page keeps per tenant. Pure; the hook is
// useTenantCookieKey.js.
//
// The explorers used to keep one cookie per user: a content type or a
// paramsId chosen on a tenant was sent to another tenant, where it does not
// exist (the MetaStore answered "reading 'cacheConfig'" and the breaker of
// the API turned the next requests into 503).

// The key of the cookie `name` of the user `nickname` on `tenant`.
export const tenantCookieKey = (name, tenant, nickname) =>
  `ares-${name}-${tenant}-${nickname}`;

// The key of the same cookie before it was kept per tenant: only removed.
export const legacyCookieKey = (name, nickname) => `ares-${name}-${nickname}`;
